export const HOME_LOGO =
  "https://w7.pngwing.com/pngs/848/762/png-transparent-computer-icons-home-house-home-angle-building-rectangle-thumbnail.png";

export const SHORTS =
  "https://pixlok.com/wp-content/uploads/2021/12/Youtube_shorts_icon-png-sdfj3.jpg";

export const SUBSCRIPTIONS = "https://image.pngaaa.com/675/4792675-middle.png";

export const YOUTUBE_LOGO =
  "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/YouTube_Logo_2017.svg/2560px-YouTube_Logo_2017.svg.png";
